import InfoCircle from '../../src/legacy/InfoCircle';
export default InfoCircle;
